<template>
    <div ref="printableDiv" >
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-4">
                        {{this.parentObject.pageTitle}} <span style="color: green;">{{ this.parentObject.pageTitleValue }}</span>
                    </h2>
                </v-row>
                <v-row>
                    <div class="pl-3 pb-2">
                        <v-row>
                            <v-col>
                                <v-btn color="warning" style="width: 70px;" @click="backHandler">{{$t('button.back') }}</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </v-row>
                    <v-row>
                        <v-col cols="4" class="pb-n5">
                            <v-text-field
                                outlined
                                :label="$t('appraisalexerciserecords.appraisalexercise')"
                                type="text"
                                ref="reviewcode"
                                v-model="formData.reviewcode"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="8" class="pb-n5">
                            <v-text-field
                                outlined
                                :label="$t('appraisalexerciserecords.appraisalexercisedescription')"
                                type="text"
                                ref="description"
                                v-model="formData.description"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('appraisalrecord.reviewtype')"
                                type="text"
                                ref="type"
                                v-model="formData.assessmentcode"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('pmreviewexercise.reviewperiodstartdate')"
                                type="date"
                                ref="startdate"
                                v-model="formData.startdate"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('pmreviewexercise.reviewperiodenddate')"
                                type="date"
                                ref="enddate"
                                v-model="formData.enddate"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('pmreviewexercise.reviewformtype')"
                                type="text"
                                ref="formtype"
                                v-model="formData.formtype"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.name')"
                                type="text"
                                ref="staffname"
                                v-model="formData.staffname"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.staffid')"
                                type="text"
                                ref="staffcode"
                                v-model="formData.staffcode"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.company')"
                                type="text"
                                ref="staffcompany"
                                v-model="formData.staffcompany"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-4">
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8 blue--text text-subtitle-2">
                           {{$t('pmreviewexercise.reviewerinfo')}}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.name')"
                                type="text"
                                ref="reviewername"
                                v-model="formData.reviewername"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.staffid')"
                                type="text"
                                ref="reviewercode"
                                v-model="formData.reviewercode"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.company')"
                                type="text"
                                ref="reviewercompany"
                                v-model="formData.reviewercompany"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('pmreviewexercise.reviewertype')"
                                type="text"
                                ref="reviewertype"
                                v-model="formData.reviewertype"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('appraisalrecord.reviewfrom')"
                                type="date"
                                ref="reviewfromdate"
                                v-model="formData.reviewfromdate"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                 :label="$t('appraisalrecord.reviewuntil')"
                                type="date"
                                ref="reviewuntildate"
                                v-model="formData.reviewuntildate"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <!-- Section -->
                    <div v-if="sectionCard" class="mt-8">
                        <v-btn @click="saveAsPDF" class="mb-2" color="primary" icon :loading="loading">
                        <template v-if="loading">
                            <v-progress-circular indeterminate color="white" size="24" class="ml-2"></v-progress-circular>
                        </template>
                        <template v-else>
                            <v-icon>mdi-download</v-icon>
                        </template>
                        </v-btn>
                        <div v-for="(item, index) in sectionList" :key="index">
                            <app-card-section
                                ref="cardSections"
                                @update-scorablesection-score="handleScorableScore"
                                @update-objectivesection-score="assignObjectiveSectionScore"
                                @update-scorablesection-rating="assignScorableItemListandRating"
                                @update-indkpi-rating="assignIndKPIListandRating"
                                v-bind:parentObject="{
                                    formData: item,
                                    reviewstaffreviewerid: parentObject.data.id,
                                    indKPIData: indKPIData,
                                    method: parentObject.data.method,
                                    isWizard: item.isWizard,
                                    totalSectWeightage: totalSectWeightage
                                }"

                            />
                        </div>

                        <v-row>
                            <v-col v-if="objectiveSectionScore != 0" cols="4" class="d-flex justify-center">
                                <v-card outlined elevation="2" class="uniform-card">
                                    <v-card-title>
                                        {{ $t('pmreviewexercise.sectionObjective') }}
                                        <span>
                                            <b>: &nbsp;&nbsp;{{ objectiveSectionScore }} / {{ objectiveSectweightage }}<span v-if="weightingUnit === 'P'">%</span></b>
                                        </span>
                                    </v-card-title>

                                </v-card>
                            </v-col>
                            <v-col v-if="totalScorableSectionScore != 0" cols="4" class="d-flex justify-center">
                                <v-card outlined elevation="2" class="uniform-card">
                                    <v-card-title>
                                        {{ $t('pmreviewexercise.sectionOthers') }}
                                        <span>
                                            <b>: &nbsp;&nbsp;{{ totalScorableSectionScore }} / {{ scorableSectweightage }}<span v-if="weightingUnit === 'P'">%</span></b>
                                        </span>
                                    </v-card-title>
                                </v-card>
                            </v-col>
                            <v-col v-if="totalScore != 0" cols="4" class="d-flex justify-center">
                                <v-card outlined elevation="2" class="uniform-card" style="background-color:#ffeab2;">
                                    <v-card-title>
                                        {{ $t('pmreviewexercise.totalscore') }}
                                        <span>
                                            <b>: &nbsp;&nbsp;{{ totalScore }} / {{ totalSectweightage}}<span v-if="weightingUnit === 'P'">%</span></b>
                                        </span>
                                    </v-card-title>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row v-if="totalScore" justify="center" align="center">
                            <v-col cols="auto" class="text-center">
                                <v-btn color="success" @click="saveHandler">{{$t('button.save')}}</v-btn>
                            </v-col>
                            <v-col cols="auto" class="text-center">
                                <v-btn color="warning" @click="cancelHandler">{{$t('button.cancel')}}</v-btn>
                            </v-col>
                        </v-row>
                    </div>
            </v-form>
        </v-container>
        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>
    </div>
</template>

<script>
import SectionCard from "./SectionCard";
import jsPDF from "jspdf";
import html2canvas from 'html2canvas';
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-card-section' : SectionCard,
        "app-error": ErrorDialog
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                id: this.parentObject.data.id,
                pmreviewexercisedid: this.parentObject.data.pmreviewexercisedid,
                pmrankmapsetid: this.parentObject.data.pmrankmapsetid,
                reviewcode: this.parentObject.data.reviewcode,
                description: this.parentObject.data.description,
                assessmentcode: this.parentObject.data.assessmentcode,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                formtype: this.parentObject.data.formtype,
                type: this.parentObject.data.type,
                staffname: this.parentObject.data.staffname,
                staffcode: this.parentObject.data.staffcode,
                staffcompany : this.parentObject.data.staffcompany,
                compnycode: this.parentObject.data.staffcompany,
                reviewername: this.parentObject.data.reviewername,
                reviewercode: this.parentObject.data.reviewercode,
                reviewercompany : this.parentObject.data.reviewercompany,
                reviewertype: this.parentObject.data.reviewertype,
                reviewfromdate: this.parentObject.data.reviewfromdate,
                reviewuntildate: this.parentObject.data.reviewuntildate,
                pmreviewformid: this.parentObject.data.pmreviewformid,
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            indKPIData: {
                pmreviewexerciseid: this.parentObject.data.pmreviewexerciseid,
                staffid: this.parentObject.data.staffid,
                reviewerid: this.parentObject.data.reviewerid,
            },

            sectionList: [],
            sectionCard: false,
            scorableSectionScores: {}, // key = section id, value = score
            objectiveSectionScore: 0,

            sectionTypeList: [],
            loading: false,
            reviewerList: [],
            rankMapSetDetails: [],

            scorableSectionRatingList: [],
            indKPIList: [],
            totalSectWeightage: 0,
            weightingUnit: null,

            errMsg: '',
            isErr: false,

            workflowStatus: null
        }
    },

    computed: {
        objectiveSectweightage() {
            const objectiveSection = this.sectionList.find(
                section => section.sectionname === "Objective"
            );
            return objectiveSection ? parseFloat(objectiveSection.sectmaxscore).toFixed(2) : "0.00"; // Default to 0 if not found
        },

        scorableSectweightage() {
            // Filter all sections with name "Scorable Section"
            const scorableSections = this.sectionList.filter(
                section => section.sectionname === "Scorable Section"
            );

            // Sum up sectmaxscore
            const total = scorableSections.reduce((sum, section) => {
                return sum + parseFloat(section.sectmaxscore || 0);
            }, 0);

            // Return with 2 decimal places
            return total.toFixed(2);
        },

        //Total of all scorable section scores
        totalScorableSectionScore() {
            return Object.values(this.scorableSectionScores)
                        .reduce((sum, val) => sum + parseFloat(val || 0), 0)
                        .toFixed(2);
        },
        
        totalScore() {
            return (
                parseFloat(this.objectiveSectionScore || 0) + 
                parseFloat(this.totalScorableSectionScore || 0)
            ).toFixed(2); // Ensure 2 decimals
        },
        totalSectweightage() {
            return (
                parseFloat(this.objectiveSectweightage || 0) + 
                parseFloat(this.scorableSectweightage || 0)
            ).toFixed(2); // Ensure 2 decimals
        },
    },

    methods: {
        async saveHandler() {
            const vm = this;

            if (vm.workflowStatus != null && vm.workflowStatus == 'PENDING'){
                vm.isErr = true;
                vm.errMsg = "Cannot save score while review workflow is still ACTIVE.";
                return;
            }

            // console.log("TOTAL SCORE", vm.totalScore);
            // console.log("formdata ID", vm.formData.id);

            // Check if totalScore is a valid number
            if (isNaN(vm.totalScore)) {
                vm.isErr = true;
                vm.errMsg = "Invalid score: totalScore is not a number.";
                return;
            }

            try {
                const res = await this.$store.dispatch('put', { 
                    url: "/reviewexercisestaff/reviewer/score/" + vm.formData.id + "/" + vm.totalScore, payload: { isHR: true }
                });

                if (res.data.error) {
                    vm.isErr = true;
                    if (Array.isArray(res.data.error)) {
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        vm.errMsg = res.data.error;
                    }
                } else {
                    //get all scores and factor for same individual review exercise (need review exercise id) and calculate average 
                    const individualScore = await this.getIndividualScore();
                    console.log("INDIVIDUALSCORE", individualScore);

                    const rank = await this.determineRank(individualScore);
                    console.log("RANK", rank);

                    this.saveINDKPIFinalRatings();
                    this.saveScorableRating();
                    this.setStaffReviewExerciseScoreandRank(individualScore, rank);
                }
            } catch (err) {
                vm.isErr = true;
                vm.errMsg = err.message || err;
            }
        },

        saveScorableRating(){
            const vm = this;

            // Add isHR to every item
            vm.scorableSectionRatingList = vm.scorableSectionRatingList.map(item => ({
                ...item,
                isHR: true,
                reviewstaffreviewerid: vm.formData.id,
                staffid: this.$store.getters.staffId
            }));

            const scorableData = {
                scorableSectionRatingList: vm.scorableSectionRatingList,
                isHR: true,
            };

            console.log("Scorable Data to Save:", scorableData);

            this.$store.dispatch('post', {url: "/reviewexercise/scorable/rating", payload: scorableData})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = true;
                    if (Array.isArray(res.data.error)) {
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        vm.errMsg = res.data.error;
                    }
                } else {
                    console.log("Saved Scorable Rating");
                }
            })
        },

        setStaffReviewExerciseScoreandRank(score, rank){
            const vm = this;

            this.$store.dispatch('put', {url: "/reviewexercise/staff/" + vm.formData.pmreviewexercisedid + "/" + score + "/" + rank, payload: { isHR: true }})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = true;
                    if (Array.isArray(res.data.error)) {
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        vm.errMsg = res.data.error;
                    }
                } else {
                    // vm.$router.push({ name: "reviewexercisestaffreviewer", params: { id: vm.formData.pmreviewexercisedid, formData: vm.formData, item: vm.formData} });
                    vm.$router.push({ name: "reviewexerciselist" });
                }
            })
        },

        getIndividualScore() {
            const vm = this;

            return this.$store.dispatch('get', { url: "/reviewexercisestaff/reviewer/" + vm.formData.pmreviewexercisedid })
                .then((res) => {
                    vm.reviewerList = res.data.rec;

                    // Calculate the sum of factors
                    const totalFactor = vm.reviewerList.reduce((sum, record) => sum + record.factor, 0);

                    // Calculate the weighted average score
                    const totalScore = vm.reviewerList.reduce((sum, record) => {
                        const weightedScore = (record.factor / totalFactor) * record.score;
                        return sum + weightedScore;
                    }, 0);

                    return totalScore;
                })
                .catch((err) => {
                    console.error(err);
                    throw err; // Ensure the error propagates
                });
        },

        //keeping for future use
        async determineRank(score) {
            console.log("SCORE", score);
            const rankMapSetDetails = await this.loadRankMapSetDetails();

            // Make sure details are sorted by uptoscore ascending
            rankMapSetDetails.sort((a, b) => a.uptoscore - b.uptoscore);

            // Find the first rank where score <= uptoscore
            const found = rankMapSetDetails.find(detail => score <= detail.uptoscore);
            console.log("FOUND", found);

            if (found) {
                return found.rank; // return the rank
            } else {
                // If score is higher than all uptoscore, return the last rank
                return rankMapSetDetails[rankMapSetDetails.length - 1]?.rank || null;
            }
        },

        //keeping for future use
        async loadRankMapSetDetails() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', { 
                    url: "/rankmapsetdetails/" + vm.formData.pmrankmapsetid 
                });

                vm.rankMapSetDetails = res.data.rec; // Set the details
                return vm.rankMapSetDetails; // Return the data if needed
            } catch (err) {
                console.error(err);
                throw err; // Rethrow the error to handle it in the calling code
            }
        },

        saveINDKPIFinalRatings(){
            const vm = this;

            vm.indKPIList = vm.indKPIList.map(item => ({
                id: item.id,
                rating: item.rating,
                updatedby: vm.formData.userid,
                stamp: vm.formData.stamp
            }));

            this.$store.dispatch('post', {url: "/reviewexercise/indkpi/finalrating/" + vm.parentObject.data.id, payload: { indKPIList: vm.indKPIList}})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = true;
                    if (Array.isArray(res.data.error)) {
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        vm.errMsg = res.data.error;
                    }
                } else {
                    console.log("Saved INDKPI Final Rating.")
                }
            })
        },


        cancelHandler() {
            this.$router.push({ name: "reviewexercisestaffreviewer", params: { id: this.formData.pmreviewexercisedid, formData: this.formData, item: this.formData, indKPIData: this.indKPIData } });
        },

        handleScorableScore({ id, score }) {
            this.assignScorableSectionScore(id, score);
        },

        assignScorableSectionScore(id, score) {
            this.$set(this.scorableSectionScores, id, score); // reactive update
        },

        assignObjectiveSectionScore(score) {
            this.objectiveSectionScore = score; 
        },

        assignScorableItemListandRating(itemlist){
            // Keep only items where scorableRating is not 0
            this.scorableSectionRatingList = itemlist.filter(item => item.scorableRating !== 0);
        },

        assignIndKPIListandRating(itemlist){
            this.indKPIList = itemlist;
            console.log("INDKPILIST", this.indKPIList);
        },

        saveAsPDF() {
            //console.log("saveasPDF");
            //console.log(this.$refs.cardSections);
            this.loading = true;
            this.$refs.cardSections.forEach(ref => {
                if (ref && typeof ref.expandPanels === 'function') {
                    ref.expandPanels();
                }
            });

            // Delay PDF generation to allow all panels to expand
            setTimeout(() => {
                const element = this.$refs.printableDiv;

                html2canvas(element, { scale: 2 })
                .then(canvas => {
                    const pdf = new jsPDF({
                    orientation: 'portrait',
                    unit: 'mm',
                    format: 'a4',
                    });

                    const pdfWidth = pdf.internal.pageSize.getWidth();
                    const pdfHeight = pdf.internal.pageSize.getHeight();

                    const padding = 8;
                    const imgWidth = pdfWidth - 2 * padding; // Adjust width for padding

                    let yOffset = padding; // Y offset for each page

                    while (yOffset < canvas.height) {
                        // Create a cropped canvas for the current page
                        const pageCanvas = document.createElement('canvas');
                        const pageContext = pageCanvas.getContext('2d');

                        pageCanvas.width = canvas.width;
                        const remainingHeight = canvas.height - yOffset;
                        pageCanvas.height = Math.min(remainingHeight, (pdfHeight - 2 * padding) * canvas.width / pdfWidth);



                        pageContext.drawImage(
                            canvas,
                            0, yOffset, // Start X, Y on original canvas
                            canvas.width, pageCanvas.height, // Width and Height to copy
                            0, 0, // Start X, Y on new canvas
                            pageCanvas.width, pageCanvas.height // Width and Height on new canvas
                        );

                        // Convert the cropped canvas to an image
                        const imgData = pageCanvas.toDataURL('image/png');

                        pdf.addImage(imgData, 'PNG', padding, padding, imgWidth, (imgWidth * pageCanvas.height) / canvas.width);

                        yOffset += pageCanvas.height;

                        // Add a new page if there is still content remaining
                        if (yOffset < canvas.height) {
                            pdf.addPage();
                        }
                    }

                    pdf.save('section-details.pdf'); // Save the generated PDF
                    this.loading = false;
                })
                .catch(error => {
                    console.error('Error generating PDF:', error);
                    this.loading = false; // Ensure loading is set to false even on error
                });
            }, 800); // Adjust delay as needed to allow full expansion
        },

        backHandler() {
            this.$router.push({ name: "reviewexercisestaffreviewer", params: { id: this.formData.pmreviewexercisedid, formData: this.formData, item: this.formData} });
        },

        loadItemSection() {
            const vm = this;

            this.$store.dispatch('get', { url: "/reviewformsection/" + vm.formData.pmreviewformid })
                .then((res) => {
                    vm.sectionList = res.data.rec;
                    if (vm.sectionList.length > 0) {
                                       
                        for (let i = 0; i < vm.sectionList.length; i++) {
                            vm.sectionList[i].isWizard = true;
                            this.assignSectionName(vm.sectionList[i].pmsectiontypeid, i);
                        }

                        // calculate total sectweightage
                        vm.totalSectWeightage = vm.sectionList.reduce((sum, item) => {
                            return sum + (parseFloat(item.sectweightage) || 0);
                        }, 0);

                        // add sectmaxscore to each item
                        vm.sectionList.forEach(item => {
                            const sectWeightage = parseFloat(item.sectweightage) || 0;
                            const maxScore = parseFloat(item.maxscore) || 0;
                            item.sectmaxscore = vm.totalSectWeightage > 0 ? (sectWeightage / vm.totalSectWeightage) * maxScore : 0;
                            console.log("sectname", item.sectname);
                            console.log("sectmaxscore", item.sectmaxscore);
                        });

                        vm.weightingUnit = vm.sectionList[0].weightingunit;

                        vm.sectionCard = true;
                    }
                }).catch((err) => {
                    console.error(err);
                });
        },

        loadSectionType(){
            const vm = this;
            
            return this.$store.dispatch('get', { url: "/reviewform/sectiontype/all"})
                .then((res) => {
                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.sectionTypeList.push({
                            id: res.data.rec[i].id,
                            description: res.data.rec[i].description,
                        });
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },

        loadWorkflowStatus(){
            const vm = this;

            this.$store.dispatch('get', { url: "/reviewexercisestaff/workflowstatus/" + vm.formData.id })
            .then((res) => {
                if (res.data.rec.length > 0) {
                    vm.workflowStatus = res.data.rec[0].wfstatus;
                }
                console.log("WORKFLOW STATUS", vm.workflowStatus);
            })
            .catch((err) => {
                console.error(err);
            });
        },

        assignSectionName(id, index) {
            const section = this.sectionTypeList.find(section => section.id === id);
            this.sectionList[index].sectionname = section ? section.description : null;
        }
    },

    mounted() {
        this.loadSectionType()
        .then(() => {
            this.loadItemSection();
        })
        .catch((err) => {
            console.error("Error loading section types:", err);
        });

        this.loadWorkflowStatus();
    },
}
</script>

<style scoped>
.uniform-card {
    height: 100px; /* Set a consistent height */
    width: 300px;
    display: flex; /* Enable flexbox */
    align-items: center; /* Center content vertically */
    justify-content: center; /* Center content horizontally */
}

.loading-spinner {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
}

.loading-spinner::before {
    content: '';
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

</style>
